import React, { useMemo, useState } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { appDocumentTitle } from '../../appMeta';
import { useAuth } from '../../auth/AuthContext';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { PageShell } from '../../layout/PageShell';
import { useNavigationMenuQuery } from '../../query/hooks';
import { SamplingCalendarTabScreen } from './TabScreens/Calendar';
import { isPetugasSampling } from '../QuotationsPage/quotationWorkflow';

type SamplingViewMode = 'calendar' | 'grid-list';

export function SamplingPage() {
  const { jwt, user } = useAuth();
  const menuQ = useNavigationMenuQuery(jwt);
  const canView = menuQ.data?.access_codes?.includes('can_view_survey') ?? false;
  const petugasSampling = isPetugasSampling(user);
  const [viewMode] = useState<SamplingViewMode>(() => (petugasSampling ? 'grid-list' : 'calendar'));
  const defaultUserId = useMemo(
    () => (petugasSampling ? Number(user?.id ?? 0) || null : null),
    [petugasSampling, user],
  );

  useDocumentTitle(appDocumentTitle('Sampling'));

  if (menuQ.isPending) {
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (menuQ.isError) {
    return (
      <Alert severity="error">
        {menuQ.error instanceof Error ? menuQ.error.message : 'Gagal memuat menu permission.'}
      </Alert>
    );
  }

  if (!canView) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <PageShell
      title="Sampling"
      subtitle={
        viewMode === 'grid-list'
          ? 'Daftar penjadwalan sampling petugas lapangan.'
          : 'Kalender sampling petugas lapangan. Klik kartu quotation untuk melihat detail.'
      }
    >
      <SamplingCalendarTabScreen defaultUserId={defaultUserId} viewMode={viewMode} />
    </PageShell>
  );
}
